import { hasActiveSubscription } from "../../../../helpers/hasActiveSubscription";

type RenderAdsByCategoryProps = {
  type: string;
};

const RenderAdsByCategory = ({ type }: RenderAdsByCategoryProps) => {
  const REVIVE_ID = "6ee315d200a003a5ac39b07d0dd34156";

  const AD_ZONES: Record<string, { mobile: string; desktop: string; mobile_source: string; desktop_source: string }> = {
    featured: { mobile: "20", mobile_source: "lobby_wide01_mob", desktop: "19", desktop_source: "lobby_wide01_desk" },
    endsTomorrow: {
      mobile: "12",
      mobile_source: "lobby_wide02_mob",
      desktop: "11",
      desktop_source: "lobby_wide02_desk",
    },
    endsSoon: { mobile: "13", mobile_source: "lobby_wide03_mob", desktop: "14", desktop_source: "lobby_wide03_desk" },
    freeCompetitions: {
      mobile: "15",
      mobile_source: "lobby_wide04_mob",
      desktop: "16",
      desktop_source: "lobby_wide04_desk",
    },
  };

  const zones = AD_ZONES[type];

  if (!zones) return null;

  return (
    <>
      {/* mobile */}
      <ins
        data-revive-usersubscriber={hasActiveSubscription()}
        data-revive-zoneid={zones.mobile}
        data-revive-id={REVIVE_ID}
        data-revive-source={zones.mobile_source}
        className="lg:hidden"
      />

      {/* desktop */}
      <ins
        data-revive-usersubscriber={hasActiveSubscription()}
        data-revive-zoneid={zones.desktop}
        data-revive-id={REVIVE_ID}
        data-revive-source={zones.desktop_source}
        className="max-lg:hidden"
      />
    </>
  );
};

export default RenderAdsByCategory;
